import React, { useState, useEffect } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import TablerLayout from "../components/layout/TablerLayout";
import dataService from "../services/dataService";
import { showErrorToast, showSuccessToast } from "../components/toasts/ToastService";

const ModellKezelo = () => {
    const navigate = useStepNavigate();
    const [modellConfigs, setModellConfigs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchModellConfigs();
    }, []);

    const fetchModellConfigs = async () => {
        setLoading(true);
        setError(null);
        
        try {
            const response = await dataService.get('/admin/modell_configs');
            
            if (response.data?.status === "ok" && response.data?.data) {
                setModellConfigs(response.data.data);
                showSuccessToast('Modell konfigurációk sikeresen betöltve!');
            } else {
                throw new Error(response.data?.message || 'Sikertelen adatlekérés');
            }
        } catch (err) {
            console.error('Modell configs fetch error:', err);
            setError(err.message || 'Hiba történt az adatok betöltése során');
            showErrorToast('Hiba történt az adatok betöltése során: ' + (err.message || err));
        } finally {
            setLoading(false);
        }
    };

    const handleBack = () => {
        navigate('/Admin');
    };

    const handleRefresh = () => {
        fetchModellConfigs();
    };

    if (loading) {
        return (
            <TablerLayout title="Modell kezelő">
                <div className="text-center">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Betöltés...</span>
                    </div>
                    <p className="mt-2">Modell konfigurációk betöltése...</p>
                </div>
            </TablerLayout>
        );
    }

    if (error) {
        return (
            <TablerLayout title="Modell kezelő">
                <div className="text-center">
                    <div className="alert alert-danger">
                        <h4>Hiba történt!</h4>
                        <p>{error}</p>
                        <button 
                            className="btn btn-primary me-2" 
                            onClick={handleRefresh}
                        >
                            Újrapróbálkozás
                        </button>
                        <button 
                            className="btn btn-secondary" 
                            onClick={handleBack}
                        >
                            Vissza
                        </button>
                    </div>
                </div>
            </TablerLayout>
        );
    }

    return (
        <TablerLayout title="Modell kezelő">
            <div className="row justify-content-center">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h3 className="card-title">Modell konfigurációk</h3>
                            <button 
                                className="btn btn-primary btn-sm"
                                onClick={handleRefresh}
                                disabled={loading}
                            >
                                Frissítés
                            </button>
                        </div>
                        <div className="card-body">
                            {modellConfigs.length === 0 ? (
                                <div className="text-center py-4">
                                    <p className="text-muted">Nincsenek elérhető modell konfigurációk.</p>
                                </div>
                            ) : (
                                <div className="table-responsive">
                                    <table className="table table-vcenter">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Név</th>
                                                <th>Kód</th>
                                                <th>Státusz</th>
                                                <th>Műveletek</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {modellConfigs.map((config) => (
                                                <tr key={config.id || config.modell_szam}>
                                                    <td>{config.id || config.modell_szam}</td>
                                                    <td>{config.name || config.modell_name}</td>
                                                    <td>{config.code || config.modell_code}</td>
                                                    <td>
                                                        <span className={`badge ${config.active || config.status === 'active' ? 'bg-success' : 'bg-secondary'}`}>
                                                            {config.active || config.status === 'active' ? 'Aktív' : 'Inaktív'}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <button 
                                                            className="btn btn-sm btn-outline-primary me-1"
                                                            onClick={() => console.log('Szerkesztés:', config)}
                                                        >
                                                            Szerkesztés
                                                        </button>
                                                        <button 
                                                            className="btn btn-sm btn-outline-danger"
                                                            onClick={() => console.log('Törlés:', config)}
                                                        >
                                                            Törlés
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                        <div className="card-footer d-flex justify-content-between">
                            <button 
                                className="btn btn-secondary"
                                onClick={handleBack}
                            >
                                Vissza az Admin oldalra
                            </button>
                            <button 
                                className="btn btn-success"
                                onClick={() => console.log('Új modell hozzáadása')}
                            >
                                Új modell hozzáadása
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </TablerLayout>
    );
};

export default ModellKezelo;